export enum ImportSourceType {
  REGISTER = 'REGISTER',
  DATABASE = 'DATABASE',
  WEBSITE = 'WEBSITE',
  ORGANISATION = 'ORGANISATION',
  HAND_SEARCH = 'HAND_SEARCH',
  CITATION_SEARCH = 'CITATION_SEARCH',
}
